export const Servidor = 'https://desofiw.xyz:12632/api/';
//export const Servidor = 'http://localhost:12621/api/';
export const UsuarioIniciarSesion = 'usuarios/iniciarsesion';
export const UsuarioEnviarPin = 'usuarios/pin';
export const UsuarioActualizarContrasena = 'usuarios/actualizar/contrasena';
//clientes
export const ClientesGuardar = Servidor + 'clientes/guardar';
export const ClientesEditar = Servidor + 'clientes/editar?id=';
export const ClienteListar = Servidor + 'clientes/listar';
export const ClienteEliminar = Servidor + 'clientes/eliminar?id=';
//ver imagen
export const ImagenCliente = Servidor + 'imagenes/clientes/';
export const ImagenEmpleado = Servidor + 'imagenes/empleados/';
export const ImagenProducto = Servidor + 'imagenes/productos/';
export const ImagenServicio = Servidor + 'imagenes/servicios/';
export const ImagenTipoProducto = Servidor + 'imagenes/productos/categorias/';
export const ImagenTipoServicio = Servidor + 'imagenes/servicios/categorias/';
//editar archivos
export const EmpleadoImagenEditar = Servidor + 'archivos/imagen/empleado?id=';
export const ClienteImagenEditar = Servidor + 'archivos/imagen/cliente?id=';
//empleados
export const EmpleadosGuardar = Servidor + 'empleados/guardar';
export const EmpleadosEditar = Servidor + 'empleados/editar?id=';
export const EmpleadosListar = Servidor + 'empleados/listar';
export const EmpleadosEliminar = Servidor + 'empleados/eliminar';
export const EmpleadoId = Servidor + 'empleados/buscarid?id=';
export const EmpleadoFiltro = Servidor + 'empleados/buscarfiltro?filtro=';
//cargos
export const CargosListar = Servidor + 'cargos/listar';
export const CargosGuardar = Servidor + 'cargos/guardar';
export const CargosEditar = Servidor + 'cargos/editar?id=';
export const CargosEliminar = Servidor + 'cargos/eliminar?id=';
export const CargoId = Servidor + 'cargos/buscarid?id=';
export const CargoNombre = Servidor + 'cargos/buscarnombre?nombre=';
//Accesos
export const AccesosListar = Servidor + 'accesos/listar';
export const AccesosGuardar = Servidor + 'accesos/guardar';
export const AccesosEliminar = Servidor + 'accesos/eliminar?id=';
export const AccesosEditar = Servidor + 'accesos/editar?id=';
//Usuarios
export const UsuariosEmpleadosListar = Servidor + 'usuarios/empleados';
//Historiales
export const HistorialesSueloListar = Servidor + 'historiales/suelo/listar';
export const HistorialesHumedadListar = Servidor + 'historiales/humedad/listar';
export const HistorialesTemperaturaListar = Servidor + 'historiales/temperatura/listar';
export const HistorialesHumedadRelativaListar = Servidor + 'historiales/humedad-relativa/listar';
export const HistorialesIluminacionListar = Servidor + 'historiales/iluminosidad/listar';
export const HistorialesActuadoresListar = Servidor + 'historiales/actuadores/listar';
//Actuadores
export const ActuadoresListar = Servidor + 'actuadores/listar';
export const ActuadoresGuardar = Servidor + 'actuadores/guardar';
export const ActuadoresEliminar = Servidor + 'actuadores/eliminar?id=';
export const ActuadoresEditar = Servidor + 'actuadores/editar?id=';
//Invernadero
export const InvernaderoListar = Servidor + 'invernaderos/listar';
export const InvernaderoListarEmpresa = Servidor + 'invernaderos/listar/empresaid';